/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function LightbulbFilament(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M176,232a8.00008,8.00008,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8.00008,8.00008,0,0,1,176,232Zm40-128a87.54352,87.54352,0,0,1-33.64209,69.208A16.2351,16.2351,0,0,0,176,185.97656V192a16.01833,16.01833,0,0,1-16,16H96a16.01833,16.01833,0,0,1-16-16v-6.03125a16.02005,16.02005,0,0,0-6.23-12.65918,87.57531,87.57531,0,0,1-33.76856-68.81445c-.26318-47.66211,38.2627-87.34961,85.88086-88.47071A88.0021,88.0021,0,0,1,216,104Zm-50.34326,2.34277a8.00182,8.00182,0,0,0-11.31348,0L128,132.68652l-26.34326-26.34375a8.00018,8.00018,0,0,0-11.31348,11.31446L120,147.314V184a8,8,0,0,0,16,0V147.314l29.65674-29.65673A8.00034,8.00034,0,0,0,165.65674,106.34277Z" />
    </Svg>
  );
}

export default LightbulbFilament;
